import { ReactNode } from 'react';

import { useLanguageUrl } from 'shared/hooks/useLanguageUrl';

import Link, { LinkProps } from 'next/link';

type NextLinkProps = {
  children: ReactNode;
  aTag?: boolean;
} & LinkProps;

function NextLink({ children, aTag, ...linkProps }: NextLinkProps): JSX.Element {
  const addLanguageToPath = useLanguageUrl();

  if (aTag) {
    const { href } = linkProps;
    return <a href={addLanguageToPath(href.toString() || '')}>{children}</a>;
  }

  return <Link {...linkProps}>{children}</Link>;
}

export default NextLink;
